import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { PopupService } from '../../shared/services/popup/popup.service';
import { ItemPopupService } from './item-popup.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs/Rx';
import { ActivatedRoute } from '@angular/router';
import { AuthServerProvider, ResponseWrapper } from '../../shared';
import { ItemService } from './item.service';

import { CONFIG } from '../../shared/constants/config.constants';
import { PermissionService } from '../../shared/utils/permissions.service';
import * as _ from 'lodash';
import { FormatNumberInputProvider } from '../../shared/components/format-number-input/format-number-input.component';
import { SystemSetting } from '../system-setting/system-setting.model';
import { TemplateType } from '../../shared/utils/template-type';
import { SystemSettingStorageService } from 'src/app/shared/utils/system-setting-storage.service';
@Component({
    selector: 'jhi-invoice-preview-invoice-template',
    templateUrl: './item-preview-invoice-template.component.html',
    styleUrls: [
        './item-preview-invoice-template.component.styl'
    ]
})
export class ItemPreviewInvoiceTemplateComponent implements OnInit {
    myCompanyInfo: any;
    // releaseInfo: any;
    invoiceTemplateId: number;
    code: string;
    invoiceId: number;
    companyId: number;
    symbol: string;
    prefix: string;
    suffix: string;
    footerInfo: any;
    pms = CONFIG.permissions;
    isHO: any = false;
    currenUserId: any;
    itemDetails: any;
    invoiceItems: any;
    invoiceStatical: any;
    invoiceGift:any;
    isUp: number = 0;
    isMultiTax : number;
    isTaxUp: number = 0;
    isTaxUp5: number = 0;
    isTaxUp10: number = 0;
    invoiceTemplates: any;
    systemSetting = new SystemSetting();
    data: any;

    
    template = CONFIG.templateName;
    x509IssuerName: any;
    x509SerialNumber: any;
    x509IssuerNameClient: any;
    x509SerialNumberClient: any;
    signature: any;
    resulftVerify: boolean;
    messege: string;
    isCheckXml: boolean;
    dataReadXml: any;
    isSignXml: boolean;
    signby: any;
    signbyClient: any;
    @ViewChild("popup") showPopup;
    @ViewChild("openModal") myModal:any;
    invoiceTemplateName: string = '';
    HuaNanHeaderInfo: any;
    totalPrice: any;
    totalAmountTax: any;

    constructor(
        public domSanitizer: DomSanitizer,
        public itemPopupService: ItemPopupService,
        public itemService: ItemService,
        public activeModal: NgbActiveModal,
        public popupService: PopupService,
        public pmSrv: PermissionService,
        private router: Router,
        private formatNumberInputProvider: FormatNumberInputProvider,
        private templateType: TemplateType,
        private systemSettingService: SystemSettingStorageService,
        ) { }

    ngOnInit() {
        this.isCheckXml = false;
        this.isCheckXml = this.itemPopupService.getIsCheckXml();
        if(this.isCheckXml){
            this.dataReadXml = this.itemPopupService.getDataOfXml();
            this.companyId = this.dataReadXml.invoiceMaster.CompanyId;
            this.loadListInvoiceTemplates();
            this.loadByXml();
        }else{
            this.invoiceTemplateId = this.itemPopupService.getTemplateId();
            //var authInfo = this.authServerProvider.getInfo();
            //this.companyId = this.itemPopupService.getCompanyId();
            // if (this.companyId == undefined) {
            //     this.myCompanyInfo = authInfo['company'];
            // } else {
            //     this.getCompanyInfo();
            // }
            this.companyId = this.data.companyId;
            this.invoiceId = this.data.id;
            this.loadListInvoiceTemplates();
            this.loadById(this.invoiceId);
        }        
        // this.releaseInfo = this.itemPopupService.getReleaseInfo();
        this.initFooterInfo();
        this.getSystemSetting(this.companyId);
    }

    // getCompanyInfo() {
    //     this.itemService.getCompanyInfo(this.companyId).subscribe(result => {
    //         this.myCompanyInfo = result;
    //     });
    // }

    getSystemSetting(companyId) {
        this.systemSettingService.getSystemSettingOneTime(companyId).subscribe(res => {
            this.systemSetting = res;
            this.changeSystemSettingForVND()
        })
    }

    initFooterInfo() {
        this.itemService.getFooterInfo().subscribe(result => {
            this.footerInfo = result;
        })
    }

    ngOnDestroy() {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }
    loadByXml(){
        this.itemDetails = this.dataReadXml.invoiceMaster;
        this.changeSystemSettingForVND()
        if(this.itemDetails.SignDate == ''){
            this.itemDetails.Month = null;
            this.itemDetails.Year = null;
            this.itemDetails.Day = null;
        }else{
            this.itemDetails.Month = this.itemDetails.SignDate.substring(3,5);
            this.itemDetails.Year = this.itemDetails.SignDate.substring(6,10);
            this.itemDetails.Day = this.itemDetails.SignDate.substring(0,2);
        }
        
        var isOrg = this.itemDetails.isOrg.toLowerCase() == 'true' ? true : false;
        this.itemDetails.isOrg = isOrg;
        //invoice details
        this.invoiceItems = this.dataReadXml.InvoiceItems;
        //bảng kê
        if(this.dataReadXml.invoiceBills){
            this.invoiceStatical = this.dataReadXml.invoiceBills;
        }
        //quà tặng
        if(this.dataReadXml.invoiceGifts){
            this.invoiceGift = this.dataReadXml.invoiceGifts;
        }
        this.checkUpdown();
        this.verify(false);

        // load invoiceTemplateName
        this.loadInvoiceTemplateNameItemDetailDoneFirst();

        // calculate total price, total amount tax for Hua Nan
        if (this.isTemplateHuaNan() || this.isTemplateMega()) {
            this.calculateTotalPrice();
        }
        
        if(!this.itemDetails.Signature){
            this.itemDetails.Signature = this.itemDetails.SignBy;
        }
        console.log(this.itemDetails);
    }
    loadById(id:number) {
        this.itemService.findPreview(id).subscribe((item) => {
            this.itemDetails = item;
            this.changeSystemSettingForVND()
            if(this.itemDetails.DateSign == ''){
                this.itemDetails.Month = null;
                this.itemDetails.Year = null;
                this.itemDetails.Day = null;
            }else{
                this.itemDetails.Month = this.itemDetails.DateRelease.substring(5,7);
                this.itemDetails.Year = this.itemDetails.DateRelease.substring(0,4);
                this.itemDetails.Day = this.itemDetails.DateRelease.substring(8,10);
            }
            //data bang ke
            this.invoiceStatical = this.itemDetails.InvoiceStatisticals;
            _.forEach(this.invoiceStatical, function(p){
                p.tradDate = p.tradDate.slice(0, -11);
            })
            //data qua tang
            this.invoiceGift = this.itemDetails.InvoiceGifts;
            _.forEach(this.invoiceGift, function(p){
                p.tradDate = p.tradDate.slice(0, -11);
            })
            this.invoiceItems = this.itemDetails.InvoiceItems;
            this.checkMultiTax(this.itemDetails.TemplateId);
            this.checkUpdown();
            // calculate total price, total amount tax for Hua Nan
            if (this.isTemplateHuaNan() || this.isTemplateMega()) {
                this.calculateTotalPrice();
            }
            // load invoiceTemplateName
            this.loadInvoiceTemplateNameItemDetailDoneFirst();
            _.forEach(this.invoiceItems, function(p){
                p.TaxName = p.DisplayInvoice;
                if(p.TaxId === 4){
                    p.AmountTax = null;
                }
            });
            this.itemDetails.Tax = this.itemDetails.TaxDisplay;
            var itemsVAT = _.find(this.invoiceItems, function(p){
                return p.productName != null && p.TaxId !== 4;
            });
            if(itemsVAT == null || itemsVAT === undefined){
                this.itemDetails.TaxAmout = null;
            }
        });
    }
    private checkUpdown(){
        if(this.itemDetails.InvoiceSample == 2){
            var TotalDown = 0;
            var TotalUp = 0;
            _.forEach(this.invoiceItems, function(value) {
                if(value.AdjustmentType == 2){
                    TotalDown += value.Total;
                }
                else{
                    TotalUp += value.Total;
                }
            });
            if(TotalUp - TotalDown > 0){
                this.isUp = 1;
            }else if(TotalUp - TotalDown < 0){
                this.isUp = -1;
            }else{
                this.isUp = 0;
            }
            if(this.isMultiTax == 1){
                var TaxDown = 0;
                var TaxUp = 0;
                var TaxDown5 = 0;
                var TaxUp5 = 0;
                var TaxDown10 = 0;
                var TaxUp10 = 0;
                _.forEach(this.invoiceItems, function(value) {
                    if(value.AdjustmentType == 2){
                        TaxDown += value.AmountTax;
                        if(value.TaxId == 2){
                            TaxDown5 += value.AmountTax;
                        }
                        if(value.TaxId == 3){
                            TaxDown10 += value.AmountTax;
                        }
                    }
                    else{
                        TaxUp += value.AmountTax;
                        if(value.TaxId == 2){
                            TaxUp5 += value.AmountTax;
                        }
                        if(value.TaxId == 3){
                            TaxUp10 += value.AmountTax;
                        }
                    }
                });
                if(TaxUp - TaxDown > 0){
                    this.isTaxUp = 1;
                }else if(TaxUp - TaxDown < 0){
                    this.isTaxUp = -1;
                }else{
                    this.isTaxUp = 0;
                }
                if(TaxUp5 - TaxDown5 > 0){
                    this.isTaxUp5 = 1;
                }else if(TaxUp5 - TaxDown5 < 0){
                    this.isTaxUp5 = -1;
                }else{
                    this.isTaxUp5 = 0;
                }
                if(TaxUp10 - TaxDown10 > 0){
                    this.isTaxUp10 = 1;
                }else if(TaxUp10 - TaxDown10 < 0){
                    this.isTaxUp10 = -1;
                }else{
                    this.isTaxUp10 = 0;
                }
            }
        }
    }
    checkMultiTax(invoiceTemplateId: string) {
        if (this.invoiceTemplates && this.invoiceTemplates.length) {
            const targetInvoice = _.find(JSON.parse(JSON.stringify(this.invoiceTemplates)), {
                invoiceTemplateId: invoiceTemplateId,
            });
            this.isMultiTax = targetInvoice.isMultiTax;
        }
    }

    loadListInvoiceTemplates() {
		this.itemService.getTemplates(this.companyId).subscribe(
			(res: ResponseWrapper) => this.onSuccessInvoiceTemplates(res.json));
	}

    private onSuccessInvoiceTemplates(invoiceTemplates) {
        this.invoiceTemplates = _.sortBy(invoiceTemplates, [function(o) { return o.code; }]);

        // load invoiceTemplateName
        this.loadInvoiceTemplateNameInvoiceTemplateListDoneFirst();
    }
    
    digitInfo(input: number): string {
        return this.formatNumberInputProvider.digitInfo(input);
    }

    
    verify(isClick: boolean) {
        if (this.dataReadXml.signature != 'undefined' && this.dataReadXml.signature != null && this.dataReadXml.signature != '') {
            this.isSignXml = true;
            this.itemService.uploadFile(this.dataReadXml.tempFileUpload).subscribe(
                (res: any) => this.onSaveSuccess(res, isClick),
                (res: Response) => this.onSaveError(res));
        } else {
            this.isSignXml = false;
            this.messege = "invoiceHaventBeenESigned";
            setTimeout(() => {
                let messageKey = this.messege;
                this.router.navigate([{
                    outlets: {
                        notification: 'notification/' + messageKey
                    }
                }], {
                        replaceUrl: true
                    });
            });
        }
    }

    standardLink(link: string): string {
        while (link[link.length - 1] === '/') {
            link = link.substr(0, link.length - 1);
        }
        return link + '/';
    }

    private onSaveSuccess(result: any, isClick: boolean) {
        
        if(result != "True"){
            this.resulftVerify = false;
            this.SetInfoSignature();
        }else{
            this.SetInfoSignature();
            this.resulftVerify = true;
        }
        if(isClick){
            this.myModal.nativeElement.click();
        }
    }
    private onSaveError(error) {
        // this.isSaving = false;
        // this.onError(error);
    }
    private SetInfoSignature(){   
        if (this.dataReadXml.signature){
            this.x509IssuerName = this.dataReadXml.signature[0].KeyInfo[0].X509Data[0].X509IssuerSerial[0].X509IssuerName[0];
            this.x509SerialNumber = this.dataReadXml.signature[0].KeyInfo[0].X509Data[0].X509IssuerSerial[0].X509SerialNumber[0];
            this.signby = this.dataReadXml.signature[0].KeyInfo[0].X509Data[0].X509SubjectName[0];
            if(this.dataReadXml.signature.length > 1){
                this.x509IssuerNameClient = this.dataReadXml.signature[1].KeyInfo[0].X509Data[0].X509IssuerSerial[0].X509IssuerName[0];
                this.x509SerialNumberClient = this.dataReadXml.signature[1].KeyInfo[0].X509Data[0].X509IssuerSerial[0].X509SerialNumber[0];
                this.signbyClient = this.dataReadXml.signature[1].KeyInfo[0].X509Data[0].X509SubjectName[0];
            }
        } 
    }

    isTemplateShinhan() {
        return this.templateType.isTemplateShinhan(this.invoiceTemplateName);
    }

    isTemplateHuaNan() {
        return this.templateType.isTemplateHuaNan(this.invoiceTemplateName);
    }

    isTemplateMega() {
        return this.templateType.isTemplateMega(this.invoiceTemplateName);
    }
    isTemplateBIDC() {
        return this.templateType.isTemplateBIDC(this.invoiceTemplateName);
    }
    initHuaNanHeaderInfo() {
        this.itemService.getHeaderInfo().subscribe(result => {
            this.HuaNanHeaderInfo = result;
        })
    }

    padLeft2(no: number) {
        if (isNaN(no)) return 0;
        var s = no.toString();
        return _.padStart(s, 2, '0');
    }

    calculateTotalPrice() {
        let totalPrice = 0;
        let totalAmountTax = 0;
        this.invoiceItems.forEach(item => {
            totalPrice += item.Price;
            totalAmountTax += item.AmountTax;
        });
        this.totalPrice = totalPrice;
        this.totalAmountTax = totalAmountTax;
    }

    loadInvoiceTemplateNameItemDetailDoneFirst() {
        // load invoiceTemplateName
        if (this.invoiceTemplates) {
            let templateFound = this.invoiceTemplates.find(x => x.code === this.itemDetails.code);
            if (!templateFound) {
                return;
            }
            this.invoiceTemplateName = templateFound.invoiceTemplateName;
            if (this.isTemplateHuaNan() || this.isTemplateMega()) {
                this.initHuaNanHeaderInfo();
            }
        }
    }

    loadInvoiceTemplateNameInvoiceTemplateListDoneFirst() {
        // load invoiceTemplateName
        if (this.itemDetails) {
            let templateFound = this.invoiceTemplates.find(x => x.code === this.itemDetails.code);
            if (!templateFound) {
                return;
            }
            this.invoiceTemplateName = templateFound.invoiceTemplateName;
            if (this.isTemplateHuaNan() || this.isTemplateMega()) {
                this.initHuaNanHeaderInfo();
            }
        }
    }

    changeSystemSettingForVND(currencyVND: boolean = null) {
        if (currencyVND === null || currencyVND === undefined) {
            currencyVND = false;
            if (this.itemDetails && this.itemDetails.CurrencyCode && this.itemDetails.CurrencyCode.toUpperCase() === 'VND') {
                currencyVND = true;
            }
        }
        if (currencyVND && !this.systemSetting.useSystemSettingVND) {
            this.systemSetting.amount = 0;
            this.systemSetting.convertedAmount = 0;
            if (this.isTemplateBIDC()) { // BIDC thì đơn giá vẫn để không dấu thập phân
                this.systemSetting.price = 0;
            }
        }
    }

    isSubstitute(): boolean {
        return this.itemDetails
            && this.itemDetails.InvoiceSample == 1
    }

    isAdjustmentInfo(): boolean {
        return this.itemDetails
            && (this.itemDetails.InvoiceSample == 3 || this.itemDetails.InvoiceSample == 5)
    }

    isAdjustmentTaxCode(): boolean {
        return this.itemDetails
            && (this.itemDetails.InvoiceSample == 5)
    }

    isAdjustmentUpDown(): boolean {
        // Là hóa đơn điều chỉnh tăng giảm: điều chỉnh tăng giảm giá thành, nhóm thuế
        return this.itemDetails
            && (this.itemDetails.InvoiceSample == 2 || this.itemDetails.InvoiceSample == 4)
    }

    isAdjustmentTax(): boolean {
        return this.itemDetails
            && this.itemDetails.InvoiceSample == 4
    }

}
